(() => {
  const instances = new Map();
  const syncSpace = () => {
    document.body.classList.toggle('wohlora-sticky-active',
      [...instances.keys()].some(bar => !bar.hidden));
  };

  const init = (root = document) => {
    root.querySelectorAll('[data-wohlora-sticky-buy]').forEach(bar => {
      if (instances.has(bar)) return;
      const bundle = document.getElementById('wohlora-buy-box');
      if (!bundle) return;
      const update = () => {
        bar.hidden = bundle.getBoundingClientRect().bottom > 24;
        syncSpace();
      };
      let observer;
      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver(update, {rootMargin: '-24px 0px 0px'});
        observer.observe(bundle);
      } else {
        window.addEventListener('scroll', update, {passive: true});
        window.addEventListener('resize', update);
      }
      instances.set(bar, () => {
        observer?.disconnect();
        window.removeEventListener('scroll', update);
        window.removeEventListener('resize', update);
      });
      update();
    });
  };

  document.addEventListener('click', event => {
    const link = event.target.closest('[data-wohlora-bundle-link]');
    if (!link || event.defaultPrevented || event.button !== 0 ||
        event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const bundle = document.getElementById('wohlora-buy-box');
    if (!bundle) return;
    event.preventDefault();
    bundle.focus({preventScroll: true});
    bundle.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      block: 'start'
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), {once: true});
  } else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [bar, cleanup] of instances) {
      if (!event.target.contains(bar)) continue;
      cleanup();
      instances.delete(bar);
    }
    syncSpace();
  });
})();
